<div class="col p-0">
  <div class="wardSelectInstitution">
    <div class="institution-name">
      <p class="m-0 selectedInsText cursor" *ngIf='showInstitutionDropDown()'> 
          {{selectedInstitution}}
        </p>
      <p class="m-0" *ngIf='!showInstitutionDropDown()'>{{getInstitutionName()  | labelSanitizer}}</p>
    </div>
  </div>
  <bd-light-table #grid
        [gridData]="gridData || [] | search:searchText" 
        [pageInfo]="pageInfo" [fields]="fields"
        [actions]="actionItems"
        [actionsLast]=true
        [addNewRow]=true
        [gridEditable]="true"
        (handlerData)="handlerData($event)"
        (addNewRowCallback)="addNew()">
        </bd-light-table>

  <!-- <lib-ph-bhp-grid [gridData]="gridData | search:searchText" [fields]="fields" [gridGroupable]="false" [pageInfo]="pageInfo" [gridEditable]="true" 
  (handlerData)="handlerData($event)"
  [formGroupModel]="wardModelGridEdit"></lib-ph-bhp-grid> -->

</div>

<ng-template #delmodal>
  <div class="mb-4 modal-header justify-content-between align-items-center">
    <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
    <a class="cursor" data-dismiss="modal" (click)="modalRef.hide();"><img
        src="assets/ph-bhp-layout/svg/remove.svg"></a>
  </div>
  <div class="modal-body">
    <p> {{ 'ERROR_MESSAGES.CONFIRMATION.DELETE.RECORD' | translate }} </p>
  </div>
  <div class="modal-footer">
    <div class="align-items-end d-flex">
      <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
      <button (click)="delete();modalRef.hide();" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
    </div>
  </div>
</ng-template>